import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Checkbox, FormControlLabel } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useContext, useEffect, useState } from "react";
import Mask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoWhite from "../assets/Logo-1.png";
import logoBlack from "../assets/Logo.png";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import { DivButton } from "../components/DivButton";
import DashboardContext from "../context/DashboardContext";
import { loginCnpj, loginCpf } from "../services";
import { NodeLogin } from "../services/SubmitEstablishment";
import { MainContainer } from "./../components/MainContainer";
import { SubContainer } from "./../components/SubContainer";

export default function UserVerify() {
  const navigation = useNavigate();

  const [userInput, setUserInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [cnpjInput, setCnpjInput] = useState(
    JSON.parse(localStorage.getItem("clientCnpj"))
  );
  const [isCpf, setIsCpf] = useState(
    JSON.parse(localStorage.getItem("clientCpf"))
  );
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    clientUser,
    clientPassword,
    clientId,
    clientCnpj,
    panelTitle,
    customPrimaryColor,
    clientLogo,
    isLoggedIn,
    setClientUser,
    setClientPassword,
    setClientId,
    setClientCnpj,
    setPanelTitle,
    setCustomPrimaryColor,
    setClientLogo,
    setIsLoggedIn,
    setAdmin,
    typeClient,
    setTypeClient,
    setMaster,
    setToken,
    setNodeToken,
  } = useContext(DashboardContext);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const trimmedUserInput = userInput.trim();
      const trimmedPasswordInput = passwordInput.trim();

      if (typeClient === "cnpj") {
        const { id, cnpj, nome2, corbackground, img } = await loginCnpj(
          trimmedUserInput,
          trimmedPasswordInput,
          cnpjInput
        );

        const nodeData = await NodeLogin({
          user: {
            user: trimmedUserInput,
            password: trimmedPasswordInput,
            cnpj: cnpjInput,
          },
        });

        setNodeToken(nodeData.token);
        localStorage.setItem("nodeToken", nodeData.token);
        const logoUrl = `https://clubecerto.com.br/images/empresas/logo/${img}`;

        if (!!id) {
          sessionStorage.setItem(
            "clientUser",
            JSON.stringify(trimmedUserInput)
          );
          sessionStorage.setItem(
            "clientPassword",
            JSON.stringify(trimmedPasswordInput)
          );
          sessionStorage.setItem("clientId", JSON.stringify(id));
          localStorage.setItem("clientCnpj", JSON.stringify(cnpj));
          sessionStorage.setItem("panelTitle", JSON.stringify(nome2));
          sessionStorage.setItem(
            "customPrimaryColor",
            JSON.stringify(corbackground)
          );
          sessionStorage.setItem("clientLogo", JSON.stringify(logoUrl));
          sessionStorage.setItem("isLoggedIn", JSON.stringify(true));
          sessionStorage.setItem("typeClient", "cnpj");

          setClientUser(trimmedUserInput);
          setClientPassword(trimmedPasswordInput);
          setClientId(id);
          setClientCnpj(cnpj);
          setPanelTitle(nome2);
          setCustomPrimaryColor(corbackground);
          setClientLogo(logoUrl);
          setIsLoggedIn(true);
          setAdmin(true);
          setTypeClient("cnpj");
        } else {
          toast.error("Credenciais incorretas");
        }
      } else {
        const worker = {
          cpf: trimmedUserInput,
          senha: trimmedPasswordInput,
        };
        const data = await loginCpf(worker);
        const nodeData = await NodeLogin({
          user: { cpf: trimmedUserInput, password: trimmedPasswordInput },
        });

        setNodeToken(nodeData.token);
        localStorage.setItem("nodeToken", nodeData.token);
        if (!data.success) {
          toast.error("Credenciais incorretas");
          return;
        }

        const logoUrl = `https://clubecerto.com.br/images/empresas/logo/${data.img}`;

        if (!!data.id) {
          if (data.admin === 1) {
            setMaster(true);
            setAdmin(false);
          } else if (data.admin === 2) {
            setAdmin(true);
            setMaster(false);
          } else {
            setMaster(false);
            setAdmin(false);
          }
          sessionStorage.setItem(
            "clientPassword",
            JSON.stringify(trimmedPasswordInput)
          );
          localStorage.setItem("clientCpf", JSON.stringify(trimmedUserInput));
          sessionStorage.setItem("panelTitle", JSON.stringify(data.nome));
          sessionStorage.setItem("clientId", JSON.stringify(data.id_empresa));
          localStorage.setItem("clientCnpj", JSON.stringify(data.cnpj));
          sessionStorage.setItem(
            "customPrimaryColor",
            JSON.stringify(data.corbackground)
          );
          sessionStorage.setItem("clientLogo", JSON.stringify(logoUrl));
          sessionStorage.setItem("isLoggedIn", JSON.stringify(true));
          sessionStorage.setItem("typeClient", "cpf");
          localStorage.setItem("token", JSON.stringify(data.token));

          setClientUser(trimmedUserInput);
          setClientPassword(trimmedPasswordInput);
          setClientId(data.id_empresa);
          setClientCnpj(data.cnpj);
          setPanelTitle(data.nome);
          setCustomPrimaryColor(data.corbackground);
          setClientLogo(logoUrl);
          setIsLoggedIn(true);
          setTypeClient("cpf");
          setToken(data.tokenJwt);
        } else {
          toast.error("Credenciais incorretas");
        }
      }
    } catch (error) {
      toast.error("Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      !!clientUser &&
      !!clientPassword &&
      !!clientId &&
      !!clientCnpj &&
      !!panelTitle &&
      !!customPrimaryColor &&
      !!clientLogo &&
      isLoggedIn
    )
      navigation("/panel");
  }, [
    clientUser,
    clientPassword,
    clientId,
    clientCnpj,
    panelTitle,
    customPrimaryColor,
    clientLogo,
    isLoggedIn,
  ]);

  return (
    <MainContainer type={typeClient}>
      <SubContainer>
        <Box
          sx={{
            backgroundClip: "border-box",
            backgroundImage: `url(${
              typeClient === "cnpj" ? logoBlack : logoWhite
            })`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            height: "150px",
            width: "200px",
            marginBottom: "10px",
          }}
        />
        <CustomContainer
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            height: "420px",
            pb: 3,
            pt: 3,
            width: "400px",
            margin: 0,
          }}
        >
          <DivButton>
            <button
              className={typeClient === "cpf" ? "active" : ""}
              onClick={() => {
                setTypeClient("cpf");
                setUserInput("");
                setPasswordInput("");
                setCnpjInput("");
              }}
            >
              Sou Colaborador
            </button>
            <button
              className={typeClient === "cnpj" ? "active" : ""}
              onClick={() => {
                setTypeClient("cnpj");
                setUserInput("");
                setPasswordInput("");
                setCnpjInput("");
              }}
            >
              Sou Gestor
            </button>
          </DivButton>

          {typeClient === "cnpj" ? (
            <form onSubmit={handleLogin}>
              <h3>Insira seus Dados de Login</h3>

              <CustomTextField
                color="cb"
                label="User"
                onChange={({ target: { value } }) => setUserInput(value.trim())}
                size="small"
                sx={{ width: "300px", marginBottom: "7px" }}
                value={userInput}
                variant="outlined"
              />

              <CustomTextField
                color="cb"
                label="Senha"
                onChange={({ target: { value } }) =>
                  setPasswordInput(value.trim())
                }
                size="small"
                sx={{ width: "300px", marginBottom: "7px" }}
                type={showPassword ? "text" : "password"}
                value={passwordInput}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Mask
                mask={isCpf ? "999.999.999-99" : "99.999.999/9999-99"}
                disabled={false}
                maskChar=" "
                onChange={({ target: { value } }) => setCnpjInput(value)}
                value={cnpjInput}
              >
                {() => (
                  <CustomTextField
                    color="cb"
                    label={isCpf ? "CPF" : "CNPJ"}
                    size="small"
                    sx={{ width: "300px", marginBottom: "7px" }}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isCpf}
                                onChange={() => setIsCpf((prev) => !prev)}
                              />
                            }
                            label="CPF"
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </Mask>
              <a href="https://clubecerto.com.br/contato">
                Não tem Clube Certo ?
              </a>

              <CustomButton
                color="buttonColor"
                disabled={!(!!userInput && !!passwordInput) || loading}
                type="submit"
                variant="contained"
                sx={{
                  marginTop: "10px",
                  width: "300px",
                  height: "50px",
                  color: "white",
                  fontWeight: "bold",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0,
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Entrar"
                )}
              </CustomButton>
              <p>
                Caiu de paraquedas ?{" "}
                <a href="https://clubecerto.com.br/contato">
                  <span>Faça parte do Clube Certo</span>
                </a>
              </p>
            </form>
          ) : (
            <form onSubmit={handleLogin}>
              <h3>Insira seu CPF e sua Senha</h3>

              <Mask
                mask="999.999.999-99"
                disabled={false}
                maskChar=" "
                onChange={({ target: { value } }) => setUserInput(value.trim())}
                value={userInput}
              >
                {() => (
                  <CustomTextField
                    color="cb"
                    label="CPF"
                    size="small"
                    sx={{ width: "300px", marginBottom: "10px" }}
                    variant="outlined"
                  />
                )}
              </Mask>

              <CustomTextField
                color="cb"
                label="Senha"
                onChange={({ target: { value } }) =>
                  setPasswordInput(value.trim())
                }
                size="small"
                sx={{ width: "300px", marginBottom: "10px" }}
                type={showPassword ? "text" : "password"}
                value={passwordInput}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <a href="https://clubecerto.com.br/contato">
                Não tem Clube Certo ?
              </a>

              <CustomButton
                color="buttonColor"
                disabled={!(!!userInput && !!passwordInput) || loading}
                type="submit"
                variant="contained"
                sx={{
                  marginTop: "10px",
                  width: "300px",
                  height: "50px",
                  color: "white",
                  fontWeight: "bold",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0,
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Entrar"
                )}
              </CustomButton>
              <p>
                Caiu de paraquedas ?{" "}
                <a href="https://clubecerto.com.br/contato">
                  <span>Faça parte do Clube Certo</span>
                </a>
              </p>
            </form>
          )}
        </CustomContainer>
      </SubContainer>
    </MainContainer>
  );
}
